/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable prefer-const */
/* eslint-disable react/jsx-one-expression-per-line */

// Upload de extratos/Cálculo do valor a receber
import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useParams, useHistory, useLocation } from 'react-router-dom';

import { Button } from 'components/Button';
import { Text, Title } from 'components/Text';
import { ALERT_TYPE } from 'components/Alert';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

import PATH from 'routes/path';
import { formatDataString } from 'services/helpers/date';
import { formatCurrency } from 'services/helpers/string';
import InfoIcon from 'assets/icons/SvgIcons/InfoIcon';
import { getFgtsById } from 'services/api/extract';
import { getCustomers, updateCustomer } from 'services/api/customers';
import { createCase } from 'services/api/cases';
import HelpIcon from '@material-ui/icons/Help';
import { Tooltip, IconButton } from '@material-ui/core';
import Loading from 'components/Loading';
import { createEventTracking } from 'services/api/tracking';
import HelpModal from './HelpModal';
import AlertModal from './AlertModal';
import {
  Negative,
  Container,
  Styles,
  Table,
  ContainerButtons,
  Wrapper,
  Header,
  TextHelp,
} from './styles';
import CalculationTooHighModal from './CalculationTooHighModal';

const Result = () => {
  const [fgtsData, setFgtsData] = useState({
    extracts: [],
  });
  const [isValueBiggerThanMaximum, setIsValueBiggerThanMaximum] = useState(false);
  const [loading, setLoading] = useState({
    saveLoading: false,
    continueLoading: false,
  });
  const [isCalculationTooHighModalOpen, setIsCalculationTooHighModalOpen] = useState(false);
  const [openHelp, setOpenHelp] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [paidOut, setPaidOut] = useState(false);
  const [createNewCase, setCreateNewCase] = useState(false);
  const [servicesHelpModal, setServicesHelpModal] = useState(false);

  const style = Styles();
  const history = useHistory();

  const params = useParams();
  const location = useLocation();

  const { enqueueSnackbar } = useSnackbar();

  const { fgts } = params;

  useEffect(() => {
    document.title = 'Resultado - Revisão FGTS - LOIT';
    window.Intercom('trackEvent', 'LOIT FGTS resultado');
    createEventTracking('100 - cálculo');
  }, []);

  const showHelp = (services) => {
    if (services) {
      window.Intercom('trackEvent', 'LOIT FGTS resultado entenda compra');
    } else {
      window.Intercom('trackEvent', 'LOIT FGTS resultado ajuda');
    }
    setServicesHelpModal(services);
    setOpenHelp(true);
  };

  const closeHelp = () => setOpenHelp(false);

  // Retorna dados do FGTS
  const getFgtsData = async () => {
    try {
      const customer = await getCustomers();
      setPaidOut(
        !location.state.homeOrigin ? false : customer.data[0].meta_data.paidOut,
      );
      setCreateNewCase(!customer.data[0].meta_data.idCase && true);

      const { data } = await getFgtsById(fgts);

      if (data.status === 'error') {
        history.push({
          pathname: PATH.CALCULATION,
          state: {
            alertText:
              'Desculpe, ocorreu um erro durante o cálculo, por favor, verifique os extratos e tente novamente.',
            alertType: ALERT_TYPE.ERROR,
          },
        });
      } else if (data.status !== 'done') {
        setTimeout(() => getFgtsData(), 4000);
      } else {
        setFgtsData(data);
        window.Intercom('trackEvent', 'LOIT FGTS valor do cálculo', {
          cálculo: data.total_value,
        });
        window.Intercom('update', {
          Cálculo: data.total_value,
        });
        const payloadCustomer = {
          ...customer.data[0],
          meta_data: {
            idCase: !location.state.homeOrigin
              ? null
              : customer.data[0].meta_data.idCase,
            idFgts: fgts,
            paidOut: !location.state.homeOrigin
              ? false
              : customer.data[0].meta_data.paidOut,
            step: !location.state.homeOrigin
              ? 0
              : customer.data[0].meta_data.step,
            newFgts: !location.state.homeOrigin && true,
            calculatedValue: data.total_value,
          },
        };
        await updateCustomer(customer.data[0].id, payloadCustomer);
        localStorage.setItem('calculated_value', data.total_value);
      }
    } catch (error) {
      const { response } = error;
      if (error.message.includes('timeout')) {
        getFgtsData();
      } else if (
        response
        && response.status !== 401
        && response.status !== 403
      ) {
        enqueueSnackbar('Desculpe, ocorreu um erro ao carragar os dados.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
    } finally {
      setLoading({
        ...loading,
        loadingContent: false,
      });
    }
  };

  const saveAndPay = async () => {
    setLoading({
      ...loading,
      loadingPayment: true,
    });

    const payload = {
      fgts,
      type: 'FGTS',
    };

    try {
      let idCase;
      if (paidOut || !location.state.homeOrigin || createNewCase) {
        const { data } = await createCase(payload);
        idCase = data.case;
        history.replace({
          state: {
            homeOrigin: true,
          },
        });
      }
      const customer = await getCustomers();
      const payloadCustomer = {
        ...customer.data[0],
        meta_data: {
          ...customer.data[0].meta_data,
          step:
            customer.data[0].meta_data.step
            && customer.data[0].meta_data.step > 1
              ? customer.data[0].meta_data.step
              : 1,
          idCase:
            paidOut || !location.state.homeOrigin || createNewCase
              ? idCase
              : customer.data[0].meta_data.idCase,
        },
      };

      await updateCustomer(customer.data[0].id, payloadCustomer);
      history.push({
        pathname: PATH.USER_DATA,
        state: {
          idCase:
            paidOut || !location.state.homeOrigin || createNewCase
              ? idCase
              : customer.data[0].meta_data.idCase,
        },
      });
    } catch (error) {
      const { response } = error;
      if (error.message.includes('timeout')) {
        saveAndPay();
      } else if (
        response
        && response.status !== 401
        && response.status !== 403
      ) {
        enqueueSnackbar(
          'Desculpe, ocorreu um erro ao salvar e comprar o caso.',
          {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          },
        );
      }
    } finally {
      setLoading({
        ...loading,
        loadingPayment: false,
      });
    }
  };

  const handleOpenCalculationTooHighModal = () => setIsCalculationTooHighModalOpen(true);
  const handleCloseCalculationTooHighModal = () => setIsCalculationTooHighModalOpen(false);

  useEffect(() => {
    const handleCheckIfCalculationValueIsTooHigh = () => {
      if (fgtsData.status !== 'done') return;

      const maximum = 78120;

      if (fgtsData.total_value > maximum) {
        setIsValueBiggerThanMaximum(true);
      } else {
        setIsValueBiggerThanMaximum(false);
      }
    };

    handleCheckIfCalculationValueIsTooHigh();
  }, [fgtsData.extracts.length]);

  const getFormattedValue = (value) => {
    if (value < 0) {
      return (
        <Negative>
          {formatCurrency(value)}
          <Tooltip
            arrow
            title="A revisão deste extrato ficou negativa. Esse valor será subtraído no Consolidado da planilha"
          >
            <IconButton size="small" color="primary" aria-label="info">
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Negative>
      );
    }

    return formatCurrency(value);
  };

  useEffect(() => {
    getFgtsData();
  }, []);

  let split = [];
  let notSplit = [];
  let formatted = [];

  // formata os extratos para os casos de split serem filhos dos extratos normais
  if (fgtsData.extracts) {
    split = fgtsData.extracts.filter(
      (item) => item.warning_code === 'split-extract',
    );
    notSplit = fgtsData.extracts.filter(
      (item) => item.warning_code !== 'split-extract',
    );

    formatted = notSplit.map((item, i) => {
      const arr = { ...item, index: i + 1, split: [] };

      split.forEach((child) => {
        if (child.employer === item.employer) {
          arr.split.push(child);
        }
      });

      return arr;
    });
  }

  return (
    <Container>
      {fgtsData.status === 'done' ? (
        <Wrapper>
          <Header>
            <Title secondary>Cálculo do valor revisado</Title>
            {/* ICONE DE AJUDA */}
            <Tooltip title="Sobre o resultado" arrow>
              <IconButton
                size="small"
                color="secondary"
                onClick={() => showHelp(false)}
                disabled={openHelp}
              >
                Ajuda
                <HelpIcon />
              </IconButton>
            </Tooltip>
            {isCalculationTooHighModalOpen && (
              <CalculationTooHighModal
                onClose={handleCloseCalculationTooHighModal}
                open={isCalculationTooHighModalOpen}
                handleContinue={saveAndPay}
              />
            )}
            {/* MODAL DE AJUDA */}
            {openHelp && (
              <HelpModal
                open={openHelp}
                services={servicesHelpModal}
                onClose={closeHelp}
              />
            )}
            {/* MODAL DE ALERTA */}
            {openAlert && (
              <AlertModal open={openAlert} onClose={setOpenAlert} />
            )}
          </Header>
          <Table>
            {formatted.map((item) => (
              <>
                <thead key={item.id}>
                  <tr>
                    <th style={{ fontWeight: 500 }}>Empresa:</th>
                    <th>
                      {item.index}. {item.employer}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Periodo apurado:</td>
                    <td>
                      {formatDataString(item.date_start)} -{' '}
                      {formatDataString(item.date_end)}
                    </td>
                  </tr>
                  <tr>
                    <td>Correção:</td>
                    <td>{getFormattedValue(item.value)}</td>
                  </tr>
                </tbody>
                {item.split.length > 0
                  && item.split.map((child, i) => (
                    <>
                      <thead key={child.id} style={{ border: 'none' }}>
                        <tr>
                          <td aria-hidden />
                          <th>
                            {item.index}.{i < 2 ? i + 2 : i + 1}{' '}
                            {child.employer}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Periodo apurado:</td>
                          <td>
                            {formatDataString(child.date_start)} -{' '}
                            {formatDataString(child.date_end)}
                          </td>
                        </tr>
                        <tr>
                          <td>Correção:</td>
                          <td>{getFormattedValue(child.value)}</td>
                        </tr>
                      </tbody>
                    </>
                  ))}
              </>
            ))}
          </Table>
          <Text className={style.text}>
            <bold style={{ fontWeight: 500 }}>
              Valor calculado para correção do seu saldo do FGTS:
            </bold>
            <span className={style.valueText}>
              {formatCurrency(fgtsData.total_value)}
            </span>
          </Text>
          <Button
            variant="contained"
            color="primary"
            onClick={isValueBiggerThanMaximum ? handleOpenCalculationTooHighModal : saveAndPay}
            loading={loading.continueLoading}
            className={style.buttonCompra}
            disabled={paidOut}
          >
            Continuar
          </Button>
          <ContainerButtons>
            <Button
              className={style.buttonCompra}
              variant="outlined"
              color="primary"
              onClick={
                paidOut
                  ? () => setOpenAlert(true)
                  : async () => {
                    window.Intercom(
                      'trackEvent',
                      'LOIT FGTS refazer calculo',
                    );
                    await createEventTracking('110 - refazer cálculo');
                    history.push(PATH.CALCULATION);
                  }
              }
              loading={loading.continueLoading}
            >
              Refazer cálculo
            </Button>
          </ContainerButtons>
          <Button
            variant="outlined"
            className="unset"
            onClick={() => history.push(PATH.HOME)}
          >
            Voltar
          </Button>
        </Wrapper>
      ) : (
        <Loading bg="none" height="100%" />
      )}
    </Container>
  );
};

export default Result;
